import Administrator from "./Administrator";
import SuperAgent from "./SuperAgent";
import Company from "./Company";

const ServiceComponent = {
  Administrator,
  SuperAgent,
  Company,
};

export default ServiceComponent;
